import { useEffect, useState } from 'react';
import api from '../api';

export type VendaPorCanal = {
  nome: string;
  canal: string;
  pedidos: number;
  valor: number;
  ticket_medio: number;
  progresso: number;
  crescimento?: string | null;
};

export type IntegracaoAtiva = {
  nome: string;
  canal: string;
  status: string;
  ultima_sync?: string | null;
};

export type AlertaDashboard = {
  tipo: string;
  titulo: string;
  descricao: string;
  link?: string;
};

export type DashboardResumo = {
  vendas_hoje: number;
  pedidos_hoje: number;
  ticket_medio_hoje: number;
  produtos_ativos: number;
  vendas_mes: number;
  total_pedidos_mes: number;
  ticket_medio_mes: number;
  canais_ativos: number;
  integracoes?: {
    sincronizacoes_ok_percentual?: number | null;
    pendentes?: number | null;
    ultima_atualizacao?: string | null;
  };
  vendas_por_canal?: VendaPorCanal[];
  integracoes_ativas?: IntegracaoAtiva[];
  alertas?: AlertaDashboard[];
};

export function useDashboardResumo() {
  const [resumo, setResumo] = useState<DashboardResumo | null>(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  async function carregarResumo() {
    try {
      setLoading(true);
      setErro(null);

      const response = await api.get('/dashboard/resumo');
      setResumo(response.data.data);
    } catch {
      setErro('Erro ao carregar resumo do dashboard.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregarResumo();
  }, []);

  return {
    resumo,
    loading,
    erro,
    recarregar: carregarResumo,
  };
}
